<template>
    <flex-element
        :element-type="elementType"
        class-default-inline="f-flex-row f-px-2 f-py-1 f-text-blue-700 hover:f-text-blue-500"
        :class="[containerClasses, 'f-flex', 'f-flex-wrap']"
        :tag="tag"
        :aria-label="ariaLabelDefault"
        exclude-classes
    >
        <div v-if="!dataSourceNew" class="f-p-0.5 f-text-gray-500">
            Please select a data source.
        </div>

        <a
            v-for="(navItem, index) in navItems"
            v-else
            :key="navItem.id"
            class="f-cursor-pointer"
            :class="[linkClasses, activeClass(index)]"
            :href="navItem.link ? navItem.link.url : ''"
            :target="navItem.link ? navItem.link.target : ''"
            @click="event => onLinkClick({ event, index, linkData: navItem })"
        >
            <slot :link-data="navItem">
                {{ navItem.text.value }}
            </slot>
        </a>
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-smart';
import NavItems from '@/graphql/queries/NavItems.gql';
import { STATE_CLASSES } from '@/data/constants/classes';
import { getClassDefinition } from '@/utils/tailwind-helper';

const publicMode = process.env.VUE_APP_ENV === 'public';

export default {
    name: 'links-nav',
    mixins: [baseOrganism],

    apollo: {
        navItems: {
            query: NavItems,

            variables() {
                return {
                    navId: this.dataSourceNew,
                };
            },

            update(data) {
                if (!data || !data.item) return [];

                this.ariaLabelDefault = this.ariaLabel ? this.ariaLabel : data.item.name;
                return data.item.children;
            },
        },
    },

    props: {
        displayName: {
            type: String,
            default: 'Dynamic Links',
        },

        dataSource: {
            type: String,
            default: '',
        },

        activeIndex: {
            type: Number,
            default: -1,
        },

        tag: {
            type: String,
            default: 'nav',
        },
    },

    data() {
        return {
            containerClassGroups: ['flexDirection'],
            ariaLabelDefault: '',
        };
    },

    computed: {
        containerClasses() {
            return this.htmlClass.filter((className) => {
                const { tailwindDefinitionProp } = getClassDefinition(className);

                return this.containerClassGroups.includes(tailwindDefinitionProp);
            });
        },

        linkClasses() {
            return this.htmlClass.filter((className) => {
                const { tailwindDefinitionProp } = getClassDefinition(className);

                return !this.containerClassGroups.includes(tailwindDefinitionProp);
            });
        },

        dataSourceNew() {
            return this.getElementData('nav-data-source') || '';
        },
    },

    watch: {
        dataSourceNew: {
            handler() {
                this.$emit('data-source-updated', this.dataSourceNew);
            },
            immediate: true,
        },
    },

    created() {
        this.setDataSource();
    },

    methods: {
        setDataSource() {
            if (this.dataSource && !this.dataSourceNew) {
                this.setElementData('nav-data-source', this.dataSource, { triggerChangeDetection: false });
            }
        },

        onLinkClick({ event, index, linkData }) {
            if (!this.previewMode && !publicMode) {
                event.preventDefault();
                return;
            }

            this.$emit('click', { event, index, linkData });
        },

        activeClass(index) {
            return index === this.activeIndex ? STATE_CLASSES.SELECTED : '';
        },
    },
};
</script>
